<template>
    <section class="app">
        <section class="header">
            <div>
                <img src="../../assets/imgs/logo.svg" height="50">
            </div>
            <div></div>
        </section>
        <section class="body">
            <div class="login">
                <div class="title">
                    <h1>Faça seu login</h1>
                </div>
                <form v-on:submit.prevent="login">
                    <div class="msg" v-if="message">{{message}}</div>
                    <div class="input-box">
                        <input id="input-username" type="text" placeholder="Digite o seu e-mail" v-model="data.username" @focus="clearMessage">
                        <label for="input-password">
                            <span>E-mail</span>
                        </label>
                    </div>
                    <div class="input-box">
                        <input id="input-password" type="password"  placeholder="Digite sua senha" v-model="data.password" @focus="clearMessage">
                        <label for="input-password">
                            <span>Senha</span>
                        </label>
                    </div>
                    <div class="control">
                        <button type="submit" :class="load ? 'load' : ''">Continuar</button>
                    </div>
                    <div class="links">
                        <div class="remember">
                            <router-link to="lembrar-senha">Esqueci minha senha</router-link>
                        </div>
                        <div class="create-account">
                             <router-link to="criar-conta">Desejo criar uma conta</router-link>
                        </div>
                    </div>
                </form>
                <div class="link-back">
                    <a href="#"><i class="fal fa-long-arrow-left"></i> Ir para a página inicial</a>
                </div>
            </div>
        </section>
        <section class="footer">
            <div>Sistema de Relacionamento e Recrutamento</div>
            <div>
                <img src="../../assets/imgs/afixar.svg">
            </div>
        </section>
    </section>
</template>

<script>
    import { login, storage } from '@/services'
    
    export default {
        name: 'login',
        data() {
            return {
                data: {
                    username: process.env.VUE_APP_USER,
                    password: process.env.VUE_APP_PASS,
                    remember: false
                },
                message: '',
                load: false,
            }
        },
        methods:{
            login(){
                this.load = true
                login.auth(this.data).then( response => {
                    storage.save(response.data, 'user', true)
                    this.$router.push({
                        name: 'dashboard'
                    })
                    this.load = false
                }, error => {
                    let code = error.response.data.code
                    switch (code) {
                        case '[jwt_auth] empty_username':
                            this.message = 'É necessário informar o nome de usuário ou e-mail.'
                            break;
                        case '[jwt_auth] empty_password':
                            this.message = 'É necessário informar sua senha de acesso.'
                            break;
                        case '[jwt_auth] invalid_email':
                            this.message = 'O e-mail informado é inválido.'
                            break;
                        case '[jwt_auth] invalid_username':
                            this.message = 'Nenhum usuário encontrado com esses dados.'
                            break;
                        case '[jwt_auth] incorrect_password':
                            this.message = 'A senha informada é inválida.'
                            break;
                        default:
                            break;
                    }
                    this.load = false
                })
            },
            check(){
                const user = storage.getUser()
                if(!user){
                    return
                }
                login.checkToken(user.token).then( response => {
                    if(!response.data.code === 'jwt_auth_valid_token'){
                        return
                    }
                    this.$router.push({ name: 'dashboard' })
                })
            },
            clearMessage(){
                this.message = ''
            }
        },
        created(){
            this.check()
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
